const DashboardIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_239_34)">
        <path
          d="M18.5714 9.28564H12.8571C12.4626 9.28564 12.1428 9.60544 12.1428 9.99993V18.5714C12.1428 18.9658 12.4626 19.2856 12.8571 19.2856H18.5714C18.9658 19.2856 19.2857 18.9658 19.2857 18.5714V9.99993C19.2857 9.60544 18.9658 9.28564 18.5714 9.28564Z"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5714 0.714355H12.8571C12.4626 0.714355 12.1428 1.03415 12.1428 1.42864V4.30007C12.1428 4.69456 12.4626 5.01436 12.8571 5.01436H18.5714C18.9658 5.01436 19.2857 4.69456 19.2857 4.30007V1.42864C19.2857 1.03415 18.9658 0.714355 18.5714 0.714355Z"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.14293 0.714355H1.42864C1.03415 0.714355 0.714355 1.03415 0.714355 1.42864V10.0001C0.714355 10.3946 1.03415 10.7144 1.42864 10.7144H7.14293C7.53741 10.7144 7.85721 10.3946 7.85721 10.0001V1.42864C7.85721 1.03415 7.53741 0.714355 7.14293 0.714355Z"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.14293 14.9858H1.42864C1.03415 14.9858 0.714355 15.3056 0.714355 15.7001V18.5716C0.714355 18.966 1.03415 19.2858 1.42864 19.2858H7.14293C7.53741 19.2858 7.85721 18.966 7.85721 18.5716V15.7001C7.85721 15.3056 7.53741 14.9858 7.14293 14.9858Z"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_239_34">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default DashboardIcon;
